/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  
  
  $(document).ready(function () {
  // 1. Initially hide all color/pattern blocks
  $('.menu__color_links').hide();
  $('.menu__pattern_links').hide(); // If using this class for pattern blocks

  // 2. Helpers to build arrow/back buttons
  function getArrowHTML(text) {
    return `
      <span class="sliderow__title">
        ${text}
        <span class="sliderule__chevron--right">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 24 24">
            <path d="M6 12h12.5m0 0-6-6m6 6-6 6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          <span class="visually-hidden">Show menu</span>
        </span>
      </span>
    `;
  }

  function getBackHTML(text) {

    return `
      <span class="sliderow__title">
        <span class="sliderule__chevron--left">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-left" viewBox="0 0 24 24">
            <path d="M18.5 12H6m0 0 6-6m-6 6 6 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </span>
        <span class="sliderule__inner">${text}</span>
      </span>
    `;
  }

  function activateSubmenu($btn, $otherBtn, text, backText, showSelector) {
    // Hide all content blocks
    $('.menu__block').hide();

    $('.sliderow.sliderow--back').hide();

    // Show relevant submenu
    $(showSelector).show();

    // Change to back button
    $btn.addClass('is-back').data('original-text', text);
    $btn.html(getBackHTML(backText));

    // Hide sibling option
    $otherBtn.hide();
    $('.shopByLinks').hide();


    // Back click resets everything
    $btn.off('click').on('click', function () {
      resetAll();
    });
  }

  function resetButton($btn) {
    const originalText = $btn.data('original-text');
    if (originalText) {
      $btn.removeClass('is-back');
      $btn.html(getArrowHTML(originalText));
    }
  }

  function resetAll() {
    // Reset buttons
    $('.sliderow[id^="shopBy"]').each(function () {
      const $btn = $(this);
      resetButton($btn);
      $('.shopByLinks').show();
      $btn.show();
    });

    // Hide submenu content
    $('.menu__block').hide();

    $('.sliderow.sliderow--back').show();


    // Re-bind click handlers
    setupClickHandlers();
  }

  function setupClickHandlers() {
    $('#shopByColourFabric').off('click').on('click', function () {
      activateSubmenu(
        $(this),
        $('#shopByPatternFabric'),
        'Shop by Colour',
        'Colours',
        '.menu__color_links[data-position="1"]'
      );
    });

    $('#shopByPatternFabric').off('click').on('click', function () {
      activateSubmenu(
        $(this),
        $('#shopByColourFabric'),
        'Shop by Category',
        'Categories',
        '.menu__block:not(.menu__color_links)'
      );
    });

    $('#shopByColourWallpaper').off('click').on('click', function () {
      activateSubmenu(
        $(this),
        $('#shopByPatternWallpaper'),
        'Shop by Colour',
        'Colours',
        '.menu__color_links[data-position="2"]'
      );
    });

    $('#shopByPatternWallpaper').off('click').on('click', function () {
      activateSubmenu(
        $(this),
        $('#shopByColourWallpaper'),
        'New Designs',
        'Patterns',
        '.menu__block:not(.menu__color_links)'
      );
    });
  }

  // Initial run
  setupClickHandlers();
});


  document.addEventListener("DOMContentLoaded", function() {
  
    document.addEventListener('click', function(event) {
      var activeTitles = document.querySelectorAll('.snize-filters-dropdown-title.active');
  
      activeTitles.forEach(function(title) {
          var content = title.nextElementSibling;
  
          console.log('Title:', title);
          console.log('Content:', content);
  
          if (content && window.getComputedStyle(content).display === 'none') {
              title.classList.remove('active');
          }
      });
  });
  


    var toggles = document.querySelectorAll('.toggle_check');

    toggles.forEach(function(toggle) {
        var targetId = toggle.getAttribute('data-toggle');
        var targetDiv = document.getElementById(targetId);
        var targetInput = targetDiv.querySelector('input');

        toggle.addEventListener('change', function() {
          console.log('toggle change');
            if (this.checked) {
                targetDiv.style.display = 'block';
                targetInput.required = true;
            } else {
                targetDiv.style.display = 'none';
                targetInput.required = false;
            }
        });
    });
});

$(document).ready(function() {
  $('a[href="#account"].btn').on('click', function(event) {
      event.preventDefault(); 

      var target = $('#account_section');
      var offset = 120;

      $('html, body').stop(true, true).animate({
        scrollTop: target.offset().top - offset
      }, 300); 
  });

});

function updateAddToCartState() {
  const $button = $('button[data-add-to-cart]');
  const variantId = $button.data('variant-id');

  const remaining = parseInt($('span.variant__countdown--low span[data-remaining-count]').text(), 10) || 999999;
  const inputQty = parseInt($('.quantity__input').val(), 10) || 0;

  $.getJSON('/cart.js', function(cart) {
    let cartQty = 0;

    cart.items.forEach(item => {
      if (item.variant_id === variantId) {
        cartQty = item.quantity;
      }
    });

    const availableQty = remaining - cartQty;

    if (inputQty > availableQty) {
      $button.prop('disabled', true).addClass('disabled');
    } else {
      $button.prop('disabled', false).removeClass('disabled');
    }

    console.log(availableQty)
    console.log(inputQty)
    console.log((inputQty > availableQty))


  });
}

$(document).ready(function() {
  updateAddToCartState();
});

$(document).on('click', '.select-popout__option', function() {
  updateAddToCartState();
});

$(document).on('click', '.cart__quantity-minus', function() {
  setTimeout(updateAddToCartState, 400);
});

$(document).on('click', '.cart__quantity-plus', function() {
  setTimeout(updateAddToCartState, 400);
});

$(document).on('input change', '.quantity__input', function() {
  updateAddToCartState();
});

$(document).on('input change', '.cart__quantity-field', function() {
  setTimeout(updateAddToCartState, 400);
});

const drawer = document.getElementById('cart-drawer');

if (drawer) {
  const classObserver = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      if (mutation.attributeName === 'class') {
        updateAddToCartState();
      }
    });
  });

  classObserver.observe(drawer, {
    attributes: true,
    attributeFilter: ['class']
  });
}


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
